 const imageElements = document.querySelectorAll('.image-container img');

const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.style.transform = 'scale(1.5)'; // Zoom 20% when the image is in the viewport
        } else {
            entry.target.style.transform = 'scale(1)'; // Reset to original scale when not in the viewport
        }
    });
}, { threshold: 0.2 }); // Adjust the threshold value as needed

imageElements.forEach((image) => {
    observer.observe(image);
});

// careers

 const tabs = document.querySelectorAll('.tab');
  const tabContents = document.querySelectorAll('.tab-content');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((tab) => tab.classList.remove('active'));
      tab.classList.add('active');

      const tabId = tab.dataset.tab;
      tabContents.forEach((content) => {
        content.classList.remove('active');
        if (content.id === tabId) {
          content.classList.add('active');
        }
      });
    });
  });



// start download page button 

    document.querySelectorAll(".download-btn").forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        const url = btn.getAttribute("href");
        const filename = url.substring(url.lastIndexOf("/") + 1);
        const getIndex = filename.indexOf(".pdf");
        const newFileName = filename.substring(0, getIndex);
        download(url, newFileName);
      });
    });

    function download(url, result) {
      fetch(url).then(function (response) {
        return response.blob().then(function (blob) {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.setAttribute("download", result);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
      });
    }
// start download page button 